import { connect } from 'react-redux';
import { pushNftEditPopup } from '../../Modals/redux/actionCreators';
import { getIsCurrentUserAuthorOf } from '../../redux/deviations/selectors';
var mapStateToProps = function (state, ownProps) { return ({
    isOwner: getIsCurrentUserAuthorOf(state, ownProps.deviation),
}); };
var mapDispatchToProps = {
    showNftEditPopup: pushNftEditPopup,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=NftDetails.container.js.map